import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'recipe/'

const initialState = {
    masterData: [],
    recipeHeads: [],
    ingredientOptions: [],
    recipeDetails: [],
    cmpltRcp: [],
    isLoading: false,
    addRecipeLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

// export const getRecipeDetails = createAsyncThunk('recipe/gdprd', async (prID, thunkAPI) => {

//     try {
//         const result = await axios.post(API_URL + 'getDraftPR/' + prID)
//         return result.data
//     } catch (error) {
//         const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
//         return thunkAPI.rejectWithValue(message)
//     }
// })

export const getRecipeMasterData = createAsyncThunk('PO/gaPR', async (_, thunkAPI) => {

    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getRecipeHeads = createAsyncThunk('recipe/heads', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'heads')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getRecipeIngredientOptions = createAsyncThunk('recipe/ingredients', async (itemHeadCode, thunkAPI) => {
    try {
        const suffix = itemHeadCode ? `?itemHeadCode=${itemHeadCode}` : ''
        const result = await axios.get(API_URL + 'ingredients' + suffix)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getRecipeData = createAsyncThunk('recipe/gvd', async (itemHeadCode, thunkAPI) => {
    try {
        console.log('itemHeadCode', itemHeadCode)
        const result = await axios.get(API_URL + 'getRecipeData/' + itemHeadCode)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const createRecipeDetail = createAsyncThunk('recipe/ardd', async (rcpdData, thunkAPI) => {
    try {

        const result = await axios.post(API_URL + 'detail/', rcpdData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getSingleItem = createAsyncThunk('recipe/gsi', async (RONO, thunkAPI) => {
    try {

        const result = await axios.get(API_URL + `detail/${RONO}`)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const updateSingleItem = createAsyncThunk('recipe/usi', async (rcpdData, thunkAPI) => {
    try {

        const result = await axios.put(API_URL + `detail/${rcpdData.RONO}`, rcpdData)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const deleteItem = createAsyncThunk('recipe/dui', async (edData, thunkAPI) => {
    try {

        const result = await axios.delete(API_URL + `detail/${edData.RONO}`, { data: edData })

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const getCompleteRecipies = createAsyncThunk('recipe/cr', async (_, thunkAPI) => {
    try {

        const result = await axios.get(API_URL + `cmpltRcp`)

        return result.data

    } catch (error) {

        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

        return thunkAPI.rejectWithValue(message)

    }
})

export const copyRecipeFromHead = createAsyncThunk('recipe/copyHead', async (payload, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'detail/copy-head', payload)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const recipeSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.masterData = []
            state.recipeHeads = []
            state.ingredientOptions = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getRecipeMasterData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getRecipeMasterData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.masterData = action.payload
            })
            .addCase(getRecipeMasterData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getRecipeHeads.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getRecipeHeads.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.recipeHeads = action.payload
            })
            .addCase(getRecipeHeads.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getRecipeIngredientOptions.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getRecipeIngredientOptions.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.ingredientOptions = action.payload
            })
            .addCase(getRecipeIngredientOptions.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getRecipeData.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getRecipeData.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.recipeDetails = action.payload.pd
            })
            .addCase(getRecipeData.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(createRecipeDetail.pending, (state) => {
                state.addRecipeLoading = true
            })
            .addCase(createRecipeDetail.fulfilled, (state, action) => {
                state.addRecipeLoading = false
                state.isSuccess = true
                state.recipeDetails = action.payload
            })
            .addCase(createRecipeDetail.rejected, (state, action) => {
                state.addRecipeLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(updateSingleItem.pending, (state) => {
                state.addRecipeLoading = true
            })
            .addCase(updateSingleItem.fulfilled, (state, action) => {
                state.addRecipeLoading = false
                state.isSuccess = true
                state.recipeDetails = action.payload
            })
            .addCase(updateSingleItem.rejected, (state, action) => {
                state.addRecipeLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(deleteItem.pending, (state) => {
                state.addRecipeLoading = true
            })
            .addCase(deleteItem.fulfilled, (state, action) => {
                state.addRecipeLoading = false
                state.isSuccess = true
                state.recipeDetails = action.payload
            })
            .addCase(deleteItem.rejected, (state, action) => {
                state.addRecipeLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getCompleteRecipies.pending, (state) => {
                state.addRecipeLoading = true
            })
            .addCase(getCompleteRecipies.fulfilled, (state, action) => {
                state.addRecipeLoading = false
                state.isSuccess = true
                state.cmpltRcp = action.payload
            })
            .addCase(getCompleteRecipies.rejected, (state, action) => {
                state.addRecipeLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(copyRecipeFromHead.pending, (state) => {
                state.addRecipeLoading = true
            })
            .addCase(copyRecipeFromHead.fulfilled, (state, action) => {
                state.addRecipeLoading = false
                state.isSuccess = true
                state.recipeDetails = action.payload
            })
            .addCase(copyRecipeFromHead.rejected, (state, action) => {
                state.addRecipeLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = recipeSlice.actions

export default recipeSlice.reducer